const AVAILABLE_SEARCH_ENTITIES = [
  'published_yacht_page',
  'published_profile',
  'published_yacht_for_sale',
  'published_yacht_for_charter'
];

const AVAILABLE_SEARCH_RESULT_KEYS = [
  'PublishedYachtPage',
  'PublishedYachtForSale',
  'PublishedProfile',
  'PublishedYachtForCharter'
];

const BUTTON_SIZES = {
  CARD: 'card',
  SIDEBAR: 'sidebar',
  SMALL: 'small'
};

const BUTTONS_BLOCK = 'contact-buttons';

const DATA_LAYER_OPTIONS = {
  BROCHURE_REQUEST: 'brochure-request',
  CALL_BACK_REQUEST: 'call-back-request',
  DECKPLANS_REQUEST: 'deckplans-request',
  FULL_SPECS_REQUEST: 'full-specs-request',
  MESSAGE: 'message',
  PHONE: 'phone',
  WEBSITE: 'website'
};

/* custom DFP lazyLoading settings */
const allowCustomLazyLoading =
  typeof window !== 'undefined' && localStorage.getItem('gpt_customEnable') === 'true';
const getOrSetDfpConfig = (key, defaultValue) => {
  if (!allowCustomLazyLoading) return defaultValue;

  const value = Number(localStorage.getItem(key)) || defaultValue;
  localStorage.setItem(key, value);
  return value;
};

const DFP_LAZY_LOAD_CONFIG =
  typeof window !== 'undefined'
    ? {
        // Fetch slots within 5 viewports.
        fetchMarginPercent: getOrSetDfpConfig('gpt_fetchMarginPercent', 50),
        // Render slots within 2 viewports.
        renderMarginPercent: getOrSetDfpConfig('gpt_renderMarginPercent', 25),
        // Double the above values on mobile, where viewports are smaller
        // and users tend to scroll faster.
        mobileScaling: getOrSetDfpConfig('gpt_mobileScaling', 1)
      }
    : true;

// eslint-disable-next-line no-console
console.log('DFP_LAZY_LOAD_CONFIG', DFP_LAZY_LOAD_CONFIG);
/* custom DFP lazyLoading settings end */

const ECOMMERCE_BUTTON_SIZES = {
  CONTACT_AND_REQUEST_CALL: 'contact-and-request-call',
  CONTACT_AND_REQUEST_CALL_MOBILE: 'contact-and-request-call-mobile',
  SIDEBAR: 'sidebar-new',
  SIDEBAR_CHARTER: 'sidebar-new-charter',
  SPECS_AND_DECKPLANS: 'specs-and-deckplans',
  MESSAGE: 'message'
};

const FORM_BLOCK = 'contact-form';

const IN_VIEW_CONFIG = {
  once: true,
  offset: '200px',
  bottomOffset: '-200px'
};

const LOGO_LABELS = {
  HEADER: 'header',
  FOOTER: 'footer'
};

const MESSAGE_TYPES = {
  BROCHURE: 'request_brochure',
  CALL_BACK: 'request_call_back',
  DECKPLANS: 'request_deck_plans',
  FULL_SPECS: 'request_full_specs',
  GENERAL: 'email_broker'
};

const MESSAGE_TYPE_TITLES = {
  [MESSAGE_TYPES.BROCHURE]: 'Request brochure',
  [MESSAGE_TYPES.CALL_BACK]: 'Request a call back',
  [MESSAGE_TYPES.DECKPLANS]: 'Request deck plans',
  [MESSAGE_TYPES.FULL_SPECS]: 'Request full specs',
  [MESSAGE_TYPES.GENERAL]: 'Email broker'
};

const MESSAGE_TYPE_TO_DATA_LAYER_OPTION = {
  [MESSAGE_TYPES.BROCHURE]: DATA_LAYER_OPTIONS.BROCHURE_REQUEST,
  [MESSAGE_TYPES.CALL_BACK]: DATA_LAYER_OPTIONS.CALL_BACK_REQUEST,
  [MESSAGE_TYPES.DECKPLANS]: DATA_LAYER_OPTIONS.DECKPLANS_REQUEST,
  [MESSAGE_TYPES.FULL_SPECS]: DATA_LAYER_OPTIONS.FULL_SPECS_REQUEST,
  [MESSAGE_TYPES.GENERAL]: DATA_LAYER_OPTIONS.MESSAGE
};

const PRIVACY = {
  HREF: 'https://privacy.informa.com/policies/en/',
  NAME: 'Privacy Policy',
  TERMS_HREF: 'https://www.boatinternational.com/terms-of-use'
};

const PROJECT_NAME = 'Boat International';

const imageSizes = {
  standardWidths: {
    '320w': {
      r: {
        width: 320
      }
    },
    '480w': {
      r: {
        width: 480
      }
    },
    '660w': {
      r: {
        width: 660
      }
    },
    '768w': {
      r: {
        width: 768
      }
    },
    '960w': {
      r: {
        width: 960
      }
    },
    '1366w': {
      r: {
        width: 1366
      }
    },
    '1367w': {
      r: {
        width: 1920
      }
    }
  },
  '16:9': {
    '320w': {
      r: {
        width: 320,
        height: 180
      }
    },
    '480w': {
      r: {
        width: 480,
        height: 270
      }
    },
    '660w': {
      r: {
        width: 660,
        height: 371
      }
    },
    '768w': {
      r: {
        width: 768,
        height: 432
      }
    },
    '960w': {
      r: {
        width: 960,
        height: 540
      }
    },
    '1366w': {
      r: {
        width: 1366,
        height: 768
      }
    },
    '1920w': {
      r: {
        width: 1920,
        height: 1080
      }
    }
  }
};

const RESPONSIVE_IMAGE_CONFIG = process.env.DISABLE_RESPONSIVE_IMAGES
  ? {}
  : {
      sizes: {
        socialMeta: {
          single: {
            r: {
              width: 1920
            }
          }
        },
        'card:landscape:list-featured': {
          widths: {
            '480w': imageSizes['16:9']['480w']
          },
          sizes: '100vw'
        },
        'card:landscape:grid--one:euclid-card-title': {
          widths: {
            '320w': imageSizes['16:9']['320w'],
            '660w': imageSizes['16:9']['660w']
          },
          sizes: '(max-width: 660px) 50vw, 10vw'
        },
        'card:landscape:grid--one:for-sale': {
          widths: {
            '320w': imageSizes['16:9']['320w'],
            '660w': imageSizes['16:9']['660w']
          },
          sizes: '(max-width: 660px) 50vw, 10vw'
        },
        'card:landscape:grid--one:sidebar-card': {
          widths: {
            '320w': imageSizes['16:9']['320w'],
            '660w': imageSizes['16:9']['660w']
          },
          sizes: '(max-width: 660px) 50vw, 10vw'
        },
        'card:landscape:list-search-results': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 660px) 100vw, 66vw'
        },
        'card:portrait:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 660px) 100vw, 50vw'
        },
        'card:portrait:grid--three': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 660px) 100vw, 33vw'
        },
        'card:landscape:grid--one:report-article--author-card': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 660px) 100vw, 10vw'
        },
        card: {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        },
        'card:landscape:cruising-areas': {
          widths: {
            // 100w is wrong but will trigger srcset correctly
            '100w': {
              r: {
                width: 100,
                height: 80
              }
            }
          },
          sizes: '100vw'
        },
        globalLightbox: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        image: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        [`carousel:longform:2`]: {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        [`carousel:longform:3`]: {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        carousel: {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        },
        'carousel:centered': {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 500
              }
            }
          },
          sizes: '100vw'
        }
      }
    };

const SEARCH_FIELDS_LIMIT = ['name'];

const SEARCH_PATH_NAME = 'search';

const CHART_COLOURS = {
  ONE: {
    backgroundColor: 'rgb(93, 170, 177)',
    borderColor: 'rgb(93, 170, 177)',
    borderWidth: 1,
    hoverBackgroundColor: 'rgba(93, 170, 177, 0.7)',
    hoverBorderColor: 'rgba(93, 170, 177, 0.7)'
  },
  TWO: {
    backgroundColor: 'rgb(242, 192, 95)',
    borderColor: 'rgb(242, 192, 95)',
    borderWidth: 1,
    hoverBackgroundColor: 'rgba(242, 192, 95, 0.7)',
    hoverBorderColor: 'rgba(242, 192, 95, 0.7)'
  }
};

export {
  AVAILABLE_SEARCH_ENTITIES,
  AVAILABLE_SEARCH_RESULT_KEYS,
  BUTTON_SIZES,
  BUTTONS_BLOCK,
  DATA_LAYER_OPTIONS,
  DFP_LAZY_LOAD_CONFIG,
  ECOMMERCE_BUTTON_SIZES,
  FORM_BLOCK,
  IN_VIEW_CONFIG,
  LOGO_LABELS,
  MESSAGE_TYPE_TITLES,
  MESSAGE_TYPE_TO_DATA_LAYER_OPTION,
  MESSAGE_TYPES,
  PRIVACY,
  PROJECT_NAME,
  RESPONSIVE_IMAGE_CONFIG,
  SEARCH_FIELDS_LIMIT,
  SEARCH_PATH_NAME,
  CHART_COLOURS
};
